<template>
  <v-select
      v-model="value"
      :items="items"
      :label="label"
      item-text="name"
      item-value="id"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {AvatarStatus} from "@/modules/redactor/models/avatar/AvatarStatus";

export default {
  name: "r-avatar-status",
  props: {
    model: VueTypes.instanceOf(AvatarStatus),
    label: VueTypes.string.def("Avatar Status:"),
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    items() {
      return AvatarStatus.getValues();
    }
  }
}

</script>